import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

import Breadcrumbs from '@/atoms/Breadcrumb'

function AboutPage() {
  const { t } = useTranslation('about')

  return (
    <div>
      <Breadcrumbs crumbs={[{ label: t('global:about_us') }]} />
      <div className="flex flex-col py-6 space-y-12 box">
        <section className="flex flex-col items-center gap-6 lg:flex-row">
          <div className="flex flex-col flex-1">
            <h1 className="flex-1 inline-block text-3xl font-medium md:text-4xl xl:text-5xl">
              {t('title')}
            </h1>
            <span className="text-3xl md:text-4xl font-medium xl:text-5xl text-[#1EBFB4]">
              {t('title_color')}
            </span>
          </div>
          <div className={'flex-1'}>
            <Image
              src="/images/fansi-about-banner.png"
              width={869}
              height={482}
              loading="eager"
            />
          </div>
        </section>
        <section className="flex flex-col gap-6 lg:flex-row-reverse">
          <div className="flex-1">
            <h2 className="text-[#1EBFB4] font-medium text-2xl">
              {t('who_are_we')}
            </h2>
            <p className="mt-2 leading-relaxed">{t('about_us_description')}</p>
          </div>
          <div className="flex-1 mt-4">
            <div className="ml-64 2xl:ml-96">
              <SunShape size="sm" className="hidden lg:block" />
            </div>
          </div>
        </section>
        <div className="flex flex-col space-y-16">
          <AreYouSection type="fan" />
          <AreYouSection type="creator" />
          <AreYouSection type="business" />
        </div>
      </div>
    </div>
  )
}

export default AboutPage

function AreYouSection({ type }: { type: 'fan' | 'creator' | 'business' }) {
  const { t } = useTranslation('about')

  const href =
    type === 'creator'
      ? '/for-creators'
      : type === 'business'
      ? '/for-brands'
      : '/'

  return (
    <section className="flex flex-col items-center max-w-2xl gap-4 mx-auto text-center">
      <Image
        width={160}
        height={160}
        loading="eager"
        src={`/assets/about/are_you_${type}.png`}
      />
      <h2 className="text-2xl font-medium text-[#1EBEB4]">
        {t(`are_you_${type}.title`)}
      </h2>
      <p>{t(`are_you_${type}.description`)}</p>
      <Link href={href}>
        <a className="block px-6 py-2 bg-opacity-70 bg-[#1EBEB4] text-white">
          {t(`are_you_${type}.button_label`)}
        </a>
      </Link>
    </section>
  )
}

const SunShape = ({
  size,
  className,
}: {
  size: 'sm' | 'md'
  className?: string
}) => (
  <span
    className={clsx('block rotate-45 bg-sbtsalmon-50 m-auto', className, {
      'w-24 h-24': size === 'sm',
      'w-36 h-36': size === 'md',
    })}
  />
)
